import React from "react";
import { capitalizeText } from "../utils";

/**
 * Basic Info Section Component
 * Product name and number fields
 */
const BasicInfoSection = ({ formData, setFormData, errors, disabled }) => {
  return (
    <div className="mb-3 grid grid-cols-1 md:grid-cols-3 gap-3">
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Product Name *
        </label>
        <input
          type="text"
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors ${
            errors.productName ? "border-red-500" : "border-gray-300"
          } ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
          value={formData.productName.en}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              productName: {
                ...prev.productName,
                en: capitalizeText(e.target.value),
              },
            }))
          }
          name="productName"
          disabled={disabled}
          placeholder="Enter product name"
        />
        {errors.productName && (
          <p className="mt-1 text-sm text-red-600">{errors.productName}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Product Number *
        </label>
        <input
          type="text"
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors ${
            errors.productNumber ? "border-red-500" : "border-gray-300"
          } ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
          value={formData.productNumber}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, productNumber: e.target.value }))
          }
          name="productNumber"
          disabled={disabled}
          placeholder="Enter product number"
        />
        {errors.productNumber && (
          <p className="mt-1 text-sm text-red-600">{errors.productNumber}</p>
        )}
      </div>
    </div>
  );
};

export default BasicInfoSection;
